module.exports = __webpack_public_path__ + "img/k3-4.a424eee1.png";